import {ButtonGroup} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {TRUST_ACCOUNT_ROLE_CONFIG} from '../config';
import {TRUST_ACCOUNT_ACCESS_SECTIONS} from '../utils';

import type {TrustAccountAccessFilter, TrustAccountAccessSection} from '../utils';
import type {FC} from 'react';

export interface TrustAccountAccessFilterButtonsProps {
  value: TrustAccountAccessFilter;
  counts: Record<TrustAccountAccessSection, number>;
  onChange: (value: TrustAccountAccessFilter) => void;
}

/** One tab per role, each with its icon and count, then "all"; a role with no accounts shows at 0, disabled. */
export const TrustAccountAccessFilterButtons: FC<TrustAccountAccessFilterButtonsProps> = ({
  value,
  counts,
  onChange
}) => {
  const {t} = useTranslation('trustAccounts');
  const total = TRUST_ACCOUNT_ACCESS_SECTIONS.reduce((sum, section) => sum + counts[section], 0);

  return (
    <ButtonGroup
      // The selected tab's icon takes the accent its count shows.
      className="w-fit max-w-full overflow-x-auto [&_[data-pressed]_[data-slot=icon]]:text-brand-accent"
      value={value}
      onChange={next => onChange(next as TrustAccountAccessFilter)}
      items={[
        ...TRUST_ACCOUNT_ACCESS_SECTIONS.map(section => ({
          value: section,
          label: t(`accessFilter.${section}`),
          icon: TRUST_ACCOUNT_ROLE_CONFIG[section].icon,
          badge: counts[section],
          disabled: counts[section] === 0
        })),
        {value: 'all', label: t('accessFilter.all'), badge: total}
      ]}
    />
  );
};
